/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2025 HG Digital/Setera
 * Todos os direitos reservados.
 * 
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 30-06-2025
 * Autor     : diegobrock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

/**
 * Status da sessão de streaming
 */
export enum StreamingSessionStatus {
  PENDING = 'PENDENTE',
  ACTIVE = 'ATIVA',
  COMPLETED = 'CONCLUIDA',
  CANCELLED = 'CANCELADA',
  EXPIRED = 'EXPIRADA'
}

/**
 * Interface para criação de sessão de streaming
 */
export interface CreateStreamingSessionRequest {
  simCard: string;
  terminalId: number;
  userId: number;
  protocol?: 'hls' | 'flv' | 'webrtc';
  duration?: number; // duração em minutos
  description?: string;
  expiresAt?: Date;
}

/**
 * Interface para resposta de sessão de streaming
 */
export interface StreamingSessionResponse {
  uuid: string;
  simCard: string;
  terminalId: number;
  userId: number;
  status: StreamingSessionStatus;
  protocol: string;
  streamName: string;
  streamUrl?: string; // NOVO: URL do stream fornecida pela API
  logicalChannel?: number; // NOVO: Canal lógico retornado pela API
  createdDate: string;
  startedAt?: string;
  expiresAt: string;
  duration: number;
  description?: string;
}

/**
 * Interface para sessão de streaming no frontend
 */
export interface IStreamingSession {
  uuid: string;
  simCard: string;
  terminalId: number;
  userId: number;
  status: StreamingSessionStatus;
  protocol: string;
  streamName: string;
  streamUrl?: string; // NOVO: URL do stream fornecida pela API
  logicalChannel?: number; // NOVO: Canal lógico retornado pela API
  createdDate: Date | undefined;
  startedAt?: Date;
  expiresAt?: Date;
  duration: number;
  description?: string;
  isExpired: boolean;
  timeRemaining?: number; // em segundos
}

/**
 * Interface para lista paginada de sessões
 */
export interface StreamingSessionListResponse {
  content: StreamingSessionResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
}

/**
 * Interface para filtros de busca de sessões
 */
export interface StreamingSessionFilters {
  status?: StreamingSessionStatus;
  simCard?: string;
  terminalId?: number;
  userId?: number;
  startedAt?: Date;
  expiresAt?: Date;
  page?: number;
  size?: number;
}

/**
 * Interface para estatísticas de sessões
 */
export interface StreamingSessionStats {
  totalSessions: number;
  activeSessions: number;
  pendingSessions: number;
  completedSessions: number;
  averageDuration: number;
  sessionsToday: number;
  sessionsThisWeek: number;
  sessionsThisMonth: number;
} 